export default "__VITE_ASSET__DMBT8L6q__"